import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class IndexService extends BaseService {
    saveMyNumber(payload: any) {
        return this.post(`${VUE_APP_API_URL}/api/account-saved-numbers`, payload).then(({ data }) => data)
    }

    getMyNumbers() {
        return this.get(`${VUE_APP_API_URL}/api/account-saved-numbers`).then(({ data }) => data)
    }

    removemyNumber(id: number) {
        return this.post(`${VUE_APP_API_URL}/api/account-saved-numbers/remove`, {id: id}).then(({ data }) => data)
        
    }
}
export default new IndexService()